/**
 * Updates CSS variables on each product-card .card-gallery so the progress
 * indicator (::after pseudo-element) can position itself dynamically based
 * on the current slide.
 *
 * Sets:
 *   --current-slide-index  number — index of the active slide (0-based)
 *   --total-slides         number — total slide count
 */

import { SlideshowSelectEvent } from '@theme/events';

function update(slideshow, index) {
  const gallery = slideshow.closest('.card-gallery');
  if (!gallery) return;
  const total = slideshow.querySelectorAll('slideshow-slide').length || 1;
  gallery.style.setProperty('--current-slide-index', String(index));
  gallery.style.setProperty('--total-slides', String(total));
}

// React to user-driven slide changes
document.addEventListener(SlideshowSelectEvent.eventName, (event) => {
  const slideshow = event.target;
  if (!(slideshow instanceof HTMLElement) || slideshow.tagName.toLowerCase() !== 'slideshow-component') return;
  update(slideshow, event.detail?.index ?? 0);
});

// Set initial values for every card slideshow on the page
function init() {
  document.querySelectorAll('.card-gallery slideshow-component').forEach((s) => update(s, 0));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
